<template>
  <LabellingTool />
</template>

<script>
import LabellingTool from '@/components/labelling/LabellingTool'

export default {
  components: {
    LabellingTool
  }
}
</script>
